var React = require('react');

function MimeVideo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3 3.746c0-.393.118-.778.338-1.106a2.035 2.035 0 0 1 2.802-.556l6.459 4.247a1.981 1.981 0 0 1 .003 3.321l-6.46 4.262c-.332.219-.722.336-1.122.336-1.115 0-2.02-.894-2.02-1.996V3.746zm2.02 0v8.508l6.46-4.262-6.46-4.246z"}));
}

MimeVideo.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = MimeVideo;

MimeVideo.default = MimeVideo;
